import { render, staticRenderFns } from "./NewCatalogs.vue?vue&type=template&id=2ff58ba3&"
import script from "./NewCatalogs.vue?vue&type=script&lang=js&"
export * from "./NewCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports